const initialState = { // default starting state 
    gpxFormat: false // By default gpx feature is disabled and is false because its a boolean and not string 
};
// Reducer function 
const gpxFormatReducer = (state = initialState, action) => { // state = initialState means if state is undefined use initialState
    switch (action.type) {
        case 'SET_GPX_FORMAT': // If action type equals SET_GPX_FORMAT execute below code 
            return {
                ...state,
                gpxFormat: action.payload // sets new value 
            };

        default:
            return state; // If reducer receives unknown action: do nothing 
    }   
};

export default gpxFormatReducer;